import { BackgroundJobKind } from '@models/backgroundJobs/IBackgroundJob';
import { backgroundJobKind } from './backgroundJobKinds';

type AnnouncementListener = (text: string) => void;

/**
 * Пауза перед объявлением: окно задачи успевает закрыться — пока открыто модальное окно, область вне его скринридер не
 * читает. Заодно повтор того же текста объявляется заново: область сперва пустеет.
 */
export const JOB_ANNOUNCE_DELAY_MS = 400;

const listeners = new Set<AnnouncementListener>();

/** Объявить скринридеру через постоянную live-область шапки (`JobLiveAnnouncer`); шапки нет — некому. */
export const announceJob = (text: string): void => listeners.forEach((listener) => listener(text));

export const subscribeJobAnnouncements = (listener: AnnouncementListener): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

/** Окно ушло, задача — в фон: подсказка у колокольчика («здесь») только визуальная, скринридеру — словами. */
export const detachedJobAnnouncement = (kind: BackgroundJobKind | null | undefined, title?: string): string =>
    `«${title?.trim() || backgroundJobKind(kind).defaultTitle}» продолжается в фоне. Итог придёт в уведомления.`;
